import React from 'react';

import clientInfoTabs from '../../CoachTools/components/ClientInfo/tabs';

const initialValues = {
  isOpen: false,
  selectedUserId: null,
  openQAP: () => {},
  closeQAP: () => {},
  selectedTab: clientInfoTabs.NOTES,
  productIdForUser: () => null,
};

const QAPContext = React.createContext(initialValues);

export default QAPContext;
export {
  initialValues,
};
